const routerInvoices = [
  {
    path: "/pedidos/cadastro/emissao-pedido",
    name: "CreateInvoice",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "CreateInvoice" */ "@/views/Invoices/CreateInvoice.vue"
      ),
  },
  {
    path: "/pedidos/franqueadora/listar",
    name: "OrdersAdmin",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "OrdersAdmin" */ "@/views/Invoices/Admin/Orders.vue"
      ),
  },
  {
    path: "/pedidos/franqueadora/editar/:order",
    name: "OrdersEditAdmin",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "OrdersEditAdmin" */ "@/views/Invoices/Admin/Edit.vue"
      ),
  },
  {
    path: "/pedidos/cadastro/pedidos-manutencao",
    name: "EditInvoice",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "EditInvoice" */ "@/views/Invoices/DraftInvoice.vue"
      ),
  },
  {
    path: "/pedidos/cadastro/duplicar-pedido",
    name: "DuplicateInvoice",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "DuplicateInvoice" */ "@/views/Invoices/DuplicateInvoice.vue"
      ),
  },
  {
    path: "/pedidos/cadastro/transferir-pedido",
    name: "TransferInvoice",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "TransferInvoice" */ "@/views/Invoices/TransferInvoice.vue"
      ),
  },
  {
    path: "/pedidos/cadastro/reabrir-pedido",
    name: "ReopenInvoice",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ReopenInvoice" */ "@/views/Invoices/ReopenInvoice.vue"
      ),
  },
  {
    path: "/pedidos/historico-transferencia",
    name: "TransferLog",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "TransferLog" */ "@/views/Invoices/TransferLog.vue"
      ),
  },
  {
    path: "/pedidos/checkout/thankyou",
    name: "CheckoutThankyou",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "CheckoutThankyou" */ "@/views/Invoices/CheckoutThankyou.vue"
      ),
  },
  {
    path: "/pedidos/checkout/:order?",
    name: "CheckoutInvoice",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "CheckoutInvoice" */ "@/views/Invoices/Checkout.vue"
      ),
  },
  {
    path: "/pedidos/promocoes",
    name: "OrdersOnSale",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "OrdersOnSale" */ "@/views/Invoices/OrdersOnSale.vue"
      ),
  },
  {
    path: "/pedidos/configuracao/condicao-pagto",
    name: "PaymentSettings",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "PaymentSettings" */ "@/views/Invoices/PaymentSettings.vue"
      ),
  },
  {
    path: "/pedidos/configuracao/especial-franquias",
    name: "PaymentSpecialFranchise",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "PaymentSpecialFranchise" */ "@/views/Invoices/PaymentSpecialFranchise.vue"
      ),
  },
  {
    path: "/pedidos/configuracao/promocoes",
    name: "ProviderPromotions",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProviderPromotions" */ "@/views/Invoices/ProviderPromotions.vue"
      ),
  },
  {
    path: "/pedidos/configuracao/promocoes/novo",
    name: "ProviderPromotionsForm",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProviderPromotionsForm" */ "@/views/Invoices/ProviderPromotionsForm.vue"
      ),
  },
  {
    path: "/pedidos/configuracao/promocoes/:id",
    name: "ProviderPromotionsEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProviderPromotionsForm" */ "@/views/Invoices/ProviderPromotionsForm.vue"
      ),
  },
  {
    path: "/pedidos/configuracao/frete",
    name: "ShippingSettings",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ShippingSettings" */ "@/views/Invoices/ShippingSettings.vue"
      ),
  },
  {
    path: "/pedidos/configuracao/frete/:id",
    name: "ShippingSettingsEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ShippingSettingsForm" */ "@/views/Invoices/ShippingSettingsForm.vue"
      ),
  },
  {
    path: "/pedidos/configuracao/frete/novo",
    name: "ShippingSettingsForm",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ShippingSettingsForm" */ "@/views/Invoices/ShippingSettingsForm.vue"
      ),
  },
  {
    path: "/pedidos/configuracao/pedido/observacao",
    name: "ObservationOrder",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "ObservationOrder" */ "@/views/Invoices/ObservationOrder.vue"
      ),
  },
  {
    path: "/pedidos/consulta-pedido",
    name: "OrderView",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "OrderView" */ "@/views/Invoices/OrderView.vue"
      ),
  },
  {
    path: "/pedidos/book",
    name: "OrderBook",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "OrderBook" */ "@/views/Invoices/Book/BookView.vue"
      ),
  },
  {
    path: "/produto/qrcode/:id",
    name: "QrcodeView",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "QrcodeView" */ "@/views/Invoices/Book/QrcodeView.vue"
      ),
  },
  {
    path: "/pedidos/cadastro/estimativa-faturamento",
    name: "DeliveryEstimate",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "DeliveryEstimate" */ "@/views/Invoices/DeliveryEstimate.vue"
      ),
  },
];

export default routerInvoices;
